import type { BuilderContent } from "@builder.io/sdk-react";

import { isObject } from "./isObject";

export function isBuilderReference(value: unknown): value is { "@type": string; value: BuilderContent } {
  return (
    isObject(value) &&
    "@type" in value &&
    value["@type"] === "@builder.io/core:Reference" &&
    "value" in value &&
    isObject(value.value) &&
    "id" in value.value
  );
}
